import { render, staticRenderFns } from "./PeaksMail.vue?vue&type=template&id=157188f4&scoped=true&"
import script from "./PeaksMail.vue?vue&type=script&lang=js&"
export * from "./PeaksMail.vue?vue&type=script&lang=js&"
import style0 from "./PeaksMail.vue?vue&type=style&index=0&id=157188f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157188f4",
  null
  
)

export default component.exports